import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from "@angular/core";
import { UnleashService } from "@karelics/angular-unleash-proxy-client";
import { take } from "rxjs";

/**
 * Most of the code taken from https://github.com/Karelics/angular-unleash-proxy-client/blob/main/projects/angular-unleash-proxy-client/src/lib/unleash.initializer.ts
 * We can't just import and use the provideUnleashProxy,
 * because Unleash config needs to be created using DI
 */
export const provideUnleashProxyInitializer = (): EnvironmentProviders => {
  return makeEnvironmentProviders([
    provideAppInitializer((): void => {
      try {
        const unleashService = inject(UnleashService);
        unleashService.initialized$
          .pipe(take(1))
          .subscribe(() => unleashService.unleash.start());
      } catch (error) {
        console.error("Failed to set up Unleash proxy client:", error.message);
      }
    }),
  ]);
};
